<script>
	// From Lucide
	import { ChevronRight } from 'lucide-svelte';

	export let iconClass = '';
</script>

<ChevronRight class={iconClass} />
